import React from 'react';
import BoxRowItemBase from './BoxRowItem';

function BoxRowItem(props) {
  return <BoxRowItemBase {...props} />;
}

export default BoxRowItem;
